import SearchProgress from '@Services/SearchProgress';
import { batchSearchProgressModalReducerKey } from './BatchSearchProgressModalConstants';

export const batchSearchProgressModal = (state) => state.get(batchSearchProgressModalReducerKey);

export const singleDatabase = (state) => batchSearchProgressModal(state).get('singleDatabase');

export const queryRunning = (state) => batchSearchProgressModal(state).get('queryRunning');

export const status = (state) => batchSearchProgressModal(state).get('status');

export const progressPercentage = (state) => batchSearchProgressModal(state).get('progressPercentage');

export const progressStatus = (state) => batchSearchProgressModal(state).get('progressStatus');

export const queriesTotal = (state) => batchSearchProgressModal(state).get('queriesTotal');

export const currentDbName = (priorityWatcher) => {
  if (!priorityWatcher) {
    return null;
  }
  return SearchProgress && SearchProgress.getCurrentDbName(priorityWatcher);
};
